import React from "react";
import { Grid, Typography, Box, Button } from "@mui/material";
import "./Newhome.css";
import { useLanguage } from "../../../utils/languageContext";

const AbdmKeyFeature = () => {
  const { t } = useLanguage();

  const features = [
    { key: "f1", icon: "/images/access.png" },
    { key: "f2", icon: "/images/schedule.png" },
    { key: "f3", icon: "/images/no-duplicate.png" },
    { key: "f4", icon: "/images/reworkhome.png" },
    { key: "f5", icon: "/images/care.png" },
    { key: "f6", icon: "/images/analytics.png" },
    { key: "f7", icon: "/images/security.png" },
    { key: "f8", icon: "/images/mobilehome.png" },
  ];

  return (
    <>
      <div className="abdm-section">
        {/* 🔷 TOP SECTION */}
        <Typography className="abdm-title">
          {t("homepage.abdm.title")}
          <span className="bgcolorspan"> {t("homepage.abdm.titleHighlight")}</span>
        </Typography>

        {/* <Typography className="abdm-subtitle">
          Comprehensive digital health infrastructure components
        </Typography> */}

        <Grid container spacing={8} className="abdm-cards">
          {/* CARD 1 */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box className="abdm-card">
              <img
                src="/images/ABHARegistration.jpeg"
                alt=""
                className="abdm-img"
              />
              <Typography className="card-title">
                {t("homepage.abdm.card1Title")}
              </Typography>
              <Typography className="card-text">
                {t("homepage.abdm.card1Text")}
              </Typography>
              <Button
                className="btn purple"  
                component="a"
                href="https://abha.abdm.gov.in/abha/v3/register"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("homepage.abdm.card1Btn")}
              </Button>
            </Box>
          </Grid>

          {/* CARD 2 */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box className="abdm-card">
              <img src="/images/HealthRecords.svg" alt="" className="abdm-img" />
              <Typography className="card-title">
                {t("homepage.abdm.card2Title")}
              </Typography>
              <Typography className="card-text">
                {t("homepage.abdm.card2Text")}
              </Typography>
              <div className="btn-group">
                <Button
                  className="btn blue"
                  component="a"
                  href="https://nhpr.abdm.gov.in/nhpr/v4/home"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("homepage.abdm.card3Btn")}
                </Button>
                <Button
                  className="yt-btn"
                  component="a"
                  href="https://www.youtube.com/watch?v=PAIGX5n290c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/images/Yoytube.png" alt="yt" />
                </Button>
              </div>
            </Box>
          </Grid>

          {/* CARD 3 */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box className="abdm-card">
              <img src="/images/HealthcareFacilities.svg" alt="" className="abdm-img" />
              <Typography className="card-title">
                {t("homepage.abdm.card3Title")}
              </Typography>
              <Typography className="card-text">
                {t("homepage.abdm.card3Text")}
              </Typography>
              <div className="btn-group">
                <Button
                  className="btn orange"
                  component="a"
                  href="https://nhpr.abdm.gov.in/nhpr/v4/home"
                  target="_blank"
                  rel="noopener noreferrer">{t("homepage.abdm.card3Btn")}</Button>
                <Button
                  className="yt-btn"
                  component="a"
                  href="https://www.youtube.com/watch?v=bhjb_HHB8Ik"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/images/Yoytube.png" alt="yt" />
                </Button>
              </div>
            </Box>
          </Grid>
        </Grid>
      </div>

      {/* ==============Key Features ========================== */}
      <div className="program-section key-feterpad">
        <Typography className="feature-title">
          {t("homepage.features.title")}{" "}
          <span className="bgcolorspan">{t("homepage.features.titleHighlight")}</span>
        </Typography>
        <Typography className="feature-subtitle">
          {t("homepage.features.subtitle")}
        </Typography>

        <Grid container spacing={3} className="feature-grid">
          {features.map((item, index) => (
            <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
              <Box className="feature-card">
                {/* Top Row (Icon + Title) */}
                <div className="feature-top">
                  <div className="keyfeature-icon">
                    <img src={item.icon} alt={t(`homepage.features.${item.key}Name`)} />
                  </div>
                  <Typography className="feature-name">
                    {t(`homepage.features.${item.key}Name`)}
                  </Typography>
                </div>
                {/* Description */}
                <Typography className="feature-desc">
                  {t(`homepage.features.${item.key}Desc`)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default AbdmKeyFeature;
